module.exports = __webpack_public_path__ + "assets/bg-in-rush-answer-c2d0e8b1.png";